import { Component, inject } from '@angular/core';

import { ApContentPipe, ApContentService } from '@ap/content';
import { ApPanelComponent } from '@ap/panel';
import { ApButtonLinkComponent } from '@ap/button';

@Component({
    selector: 'appointment',
    standalone: true,
    imports: [ApPanelComponent, ApButtonLinkComponent, ApContentPipe],
    templateUrl: './appointment.component.html'
})
export class AppointmentComponent {
    private readonly contentService = inject(ApContentService);

    getAppointmentUrl(): string {
        return this.contentService.get('interest-overview.appointmentButton.url');
    }

    getMaxMortgageUrl(): string {
        return this.contentService.get('interest-overview.max-mortgage.url');
    }
}
